module.exports = __webpack_public_path__ + "components/MapControl/svg/Fort_twierdza.svg?77b96d4f";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Fort_twierdza.svg
// module id = 1927
// module chunks = 0